import type { OTPInputProps } from '../OTPInput/index.ts';
import type { FormComponentProps } from './types.ts';
import { OTPInput } from '../OTPInput/index.ts';
import { useFieldContext } from './BaseForm.ts';
import { usePropsFromField } from './utils.ts';

export function FormOTPInput(props: FormComponentProps<Omit<OTPInputProps, 'onChange' | 'value'>>) {
  const field = useFieldContext<string>();

  return (
    <OTPInput
      key={field.name}
      {...usePropsFromField(props, field)}
      onBlur={field.handleBlur}
      onChange={field.handleChange}
      value={field.state.value}
    />
  );
}
